export const zeroIfFalsy = (condition, parameter) => {
  return condition ? (parameter ? parameter : 0) : 0
}

export const emptyArrayIfFalsy = (condition, parameter) => {
  return condition ? (parameter ? parameter : []) : []
}

export const getNextDateMidnight = date => {
  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + 1)
  return date.toISOString()
}
